import React from 'react';
import { Link, Typography } from "../../ecosystem";

const LinkRecord = ({
    to,
}) => {

    return (
        <div className="proxy-home-link-record-msg">
            <Typography type="body-01">
                You can link your record <Link to={to}>here.</Link>
            </Typography>
        </div>
    );
}

export default LinkRecord;
